/* ════════════ THE QUERY LOG ════════════
   The google page's atmosphere: half-typed search queries drift
   past with a blinking cursor. Most just fade. Some get stamped
   "→ logged" first. Statistically, all of them did. */

import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function querylog(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#querylog")!;
  const ctx = c.getContext("2d")!;

  const BLUE = "#69b1ff";
  const GREY = "#9aa0a6";

  const QUERIES = [
    "symptoms of",
    "how to leave",
    "lawyer near me",
    "is it normal to",
    "how to delete search history",
    "cheap flights one way",
    "can my employer see",
    "do i have to tell",
    "how long does it take to",
    "signs that someone is",
    "is incognito actually private",
    "what happens if i don't",
    "therapist that takes",
    "how much debt is too much",
  ];

  type Query = {
    x: number;
    y: number;
    t: number; // age in frames
    life: number;
    text: string;
    logged: boolean; // earns the blue stamp before fading
    vy: number;
  };
  let queries: Query[] = [];

  const spawn = (): Query => ({
    x: 20 + Math.random() * Math.max(40, c.width - 220),
    y: 30 + Math.random() * Math.max(40, c.height - 60),
    t: 0,
    life: 320 + Math.random() * 280,
    text: QUERIES[Math.floor(Math.random() * QUERIES.length)]!,
    logged: Math.random() < 0.3,
    vy: -0.04 - Math.random() * 0.05,
  });

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(16, Math.floor((c.width * c.height) / 110000));
    queries = Array.from({ length: count }, () => {
      const q = spawn();
      q.t = Math.random() * q.life; // desync
      return q;
    });
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    ctx.font = "11px 'IBM Plex Mono', monospace";
    for (const q of queries) {
      const p = q.t / q.life;
      const a = p < 0.12 ? p / 0.12 : p > 0.75 ? (1 - p) / 0.25 : 1;
      // the query types itself out over the first 35% of its life
      const shown = q.text.slice(
        0,
        Math.ceil(q.text.length * Math.min(1, p / 0.35)),
      );
      ctx.globalAlpha = a * 0.18;
      ctx.fillStyle = GREY;
      ctx.fillText(shown, q.x, q.y);
      // blinking cursor at the end of the line
      if (Math.floor(q.t / 28) % 2 === 0) {
        const w = ctx.measureText(shown).width;
        ctx.fillRect(q.x + w + 3, q.y - 9, 6, 11);
      }
      // some queries get the stamp. statistically, all of them did.
      if (q.logged && p > 0.55) {
        const w = ctx.measureText(q.text).width;
        ctx.globalAlpha = a * 0.45;
        ctx.fillStyle = BLUE;
        ctx.fillText("→ logged", q.x + w + 16, q.y);
      }
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (let i = 0; i < queries.length; i++) {
      const q = queries[i]!;
      q.t++;
      q.y += q.vy;
      if (q.t >= q.life || q.y < 14) queries[i] = spawn();
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage(querylog);
